import { render } from "./ListTable.vue?vue&type=template&id=2c8eb2b2&scoped=true"
import script from "./ListTable.vue?vue&type=script&lang=js"
export * from "./ListTable.vue?vue&type=script&lang=js"

import "./ListTable.vue?vue&type=style&index=0&id=2c8eb2b2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8eb2b2"]])

export default __exports__